import axios from 'axios';

export const betsRequest = (id: string) => axios.get(`/v1/tipsters/${id}/tips`);

export const betEditRequest = (values: any) => {
  return axios.put(`/v1/tips/${values.id}/finish`, values);
};

export const createBet = (formData: any) =>
  axios.post(`/v1/tips`, formData, {
    headers: { 'Content-Type': 'application/json' },
  });

// Batch result interface
export interface BatchResult {
  channel_id: string;
  success: boolean;
  tip_id?: string;
  error?: string;
}

// Batch create function - publishes to multiple channels in parallel
export const createBetBatch = async (
  baseDto: any,
  channelIds: string[],
): Promise<BatchResult[]> => {
  const promises = channelIds.map(async (channelId) => {
    try {
      const dto = { ...baseDto, channel_id: channelId };
      const response: any = await axios.post('/v1/tips', dto, {
        headers: { 'Content-Type': 'application/json' },
      });
      return {
        channel_id: channelId,
        success: true,
        tip_id: response?.tip?.id,
      };
    } catch (error: any) {
      return {
        channel_id: channelId,
        success: false,
        error: error?.message || 'Unknown error',
      };
    }
  });
  return Promise.all(promises);
};

export const uploadFile = (mediaFormData: any) => {
  return axios.post(`/v1/files`, mediaFormData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const ownedBetsRequest = (openstatus: any) => {
  if (openstatus.payload.openstatus === 'closed') {
    return axios.get(`/v1/tips/owned?limit=30&tip_result=closed`);
  } else if (openstatus.payload.openstatus === 'open') {
    return axios.get(`/v1/tips/owned?limit=40&tip_result=open`);
  } else {
    const cursor = openstatus.payload.openstatus;
    return axios.get(
      `/v1/tips/owned?limit=10&tip_result=closed&cursor=${cursor}`,
    );
  }
};
